<template>
  <div class="button-wrapper">
    <button @click="clickDeleteBtn">
      <Icons name="Delete" color="#5D3EBC" />
      Sil
    </button>
  </div>
</template>

<script>
import { Icons } from '@n11/so-ui-components';
import { mapMutations } from "vuex";

export default {
  name: 'DeleteButton',
  components: { Icons },
  props: {
    pid: {
      type: [String, Number],
      required: true,
    }
  },
  computed: {},
  methods: {
    ...mapMutations('navigation', ['SET_CATALOG_MODAL_DELETE_ROW_ID']),
    clickDeleteBtn() {
      this.SET_CATALOG_MODAL_DELETE_ROW_ID(this.pid);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.button-wrapper {
  width: 30px;

  > button {
    color: $colorM50;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 2px;
  }
}

</style>
